import { render, staticRenderFns } from "./SearchDocuments.vue?vue&type=template&id=021d7979"
import script from "./SearchDocuments.vue?vue&type=script&lang=js"
export * from "./SearchDocuments.vue?vue&type=script&lang=js"
import style0 from "./SearchDocuments.vue?vue&type=style&index=0&id=021d7979&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports